var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('section',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col"},[_c('h2',[_vm._v(_vm._s(_vm.title))])])])])])}
var staticRenderFns = []

export { render, staticRenderFns }